let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5FPXG")).then(() => parcelRequire('gfPrw'));